import { useState } from "react";
import { Menu, X, Linkedin, Facebook } from "lucide-react";

const NAV_LINKS = [
  { name: "Start Here", href: "#start-here", testid: "nav-link-start-here" },
  { name: "Coaching", href: "#packages", testid: "nav-link-coaching" },
  { name: "Sleep & Recovery", href: "#sleep-recovery", testid: "nav-link-sleep-recovery" },
  { name: "Legal Protection", href: "#legal-protection", testid: "nav-link-legal-protection" },
  { name: "About", href: "#about", testid: "nav-link-about" },
  { name: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/85 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a
          href="#top"
          data-testid="logo-link"
          className="font-display text-base font-bold tracking-tight text-slate-900 sm:text-lg"
        >
          Now <span className="text-blue-700">LifeWorks</span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Main navigation">
          {NAV_LINKS.map((link) => (
            <a
              key={link.name}
              data-testid={link.testid}
              href={link.href}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-blue-700"
            >
              {link.name}
            </a>
          ))}
          <span className="ml-1 flex items-center gap-2 border-l border-slate-200 pl-4">
            <a
              href="https://www.linkedin.com/in/joinjohnjones/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-social-linkedin"
              aria-label="John Jones on LinkedIn"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0A66C2] text-white transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://www.facebook.com/thisisjohnjones/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-social-facebook"
              aria-label="John Jones on Facebook"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-[#1877F2] text-white transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </span>
        </nav>

        <button
          data-testid="mobile-menu-button"
          className="rounded-lg p-2 text-slate-700 transition-colors hover:bg-slate-100 lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="flex flex-col gap-1 border-t border-slate-200 bg-white/95 px-4 py-4 lg:hidden"
          aria-label="Mobile navigation"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.name}
              data-testid={`mobile-${link.testid}`}
              href={link.href}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-blue-50 hover:text-blue-700"
            >
              {link.name}
            </a>
          ))}
          <div className="mt-4 flex items-center justify-center gap-3">
            <a
              href="https://www.linkedin.com/in/joinjohnjones/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-social-linkedin"
              aria-label="John Jones on LinkedIn"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-[#0A66C2] text-white"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://www.facebook.com/thisisjohnjones/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-social-facebook"
              aria-label="John Jones on Facebook"
              className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1877F2] text-white"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
